const mapFileFromApi = (
  resp: ApiFileResponse | null | undefined
): RemoteFile => {
  return {
    url: resp?.url ?? '',
    previewUrl: resp?.preview_url ?? null,
    extension: resp?.extension ?? null,
    fileName: resp?.file_name ?? null,
    height: resp?.height ?? null,
    size: resp?.size ?? null,
    width: resp?.width ?? null,
    previewHeight: resp?.preview_height ?? null,
    previewWidth: resp?.preview_width ?? null,
    typeId: resp?.type_id ?? null,
  };
};

export default mapFileFromApi;
